function addImageBannerSliderItem(
    imageList = [],
    customBannerImageLink = null,
    customBannerImageDesktop = '',
    customBannerImageMobile = ''
) {
    var customBannerImage = isDesktop ? customBannerImageDesktop : customBannerImageMobile;
    imageList.push({
        banner_image_link: customBannerImageLink,
        banner_image: customBannerImage 
    });
    return imageList;
}

function renderCustomImageBannerSliderElement(
    customBannerSliderImagerContainer,
    customBannerSliderImages,
    customBannerSliderConfig
) {
    $(customBannerSliderImages).each(function (index, item) {
        if (item.banner_image_link !== null) {
            customBannerSliderImagerContainer.append(
                $('<a>', {
                    href: item.banner_image_link,
                    class: customBannerSliderConfig['banner_title'] + '-link'
                }).append(
                    $('<div>', {
                        class: 'custom-banner-slider-image'
                    }).append(
                        $('<img>', {
                            src: item.banner_image,
                            alt: 'banner-image',
                            loading:'eager',
                        })
                    )
                )
            );
        } else {
            customBannerSliderImagerContainer.append(
                $('<div>', {
                    class: 'custom-banner-slider-image'
                }).append(
                    $('<img>', {
                        src: item.banner_image,
                        alt: 'banner-image',
                        loading:'eager',
                    })
                )
            );
        }
    });

    customBannerSliderImagerContainer.owlCarousel({
        autoplay: customBannerSliderConfig['autoplay'],
        autoplayTimeout: customBannerSliderConfig['autoplay_slide_duration'],
        loop: customBannerSliderConfig['is_looping'],
        slideSpeed : 300,
        paginationSpeed : 400,
        items : 1
    });
}